import React from 'react';
function Heading4({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 4v16M4.5 12h8M13 4v16M21 12.5L17 18M17 18h4M21 12.5V20"
      />
    </svg>
  );
}

export default Heading4;
